<script>
import axios from "axios";
import appConfig from "@/app.config";
export default {
  page: {
    title: "Login ",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      phone: "",
      error: "",
      loader: false,
    };
  },
  methods: {
    async login() {
      this.loader = true;
      let formData = new FormData();
      formData.append("phone", "+256"+this.phone);
      let url = "/checknumber";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          localStorage.setItem("phone", this.phone);
          if(response.data.error==true){
            this.$router.push({name: "verify",});
            this.error = response.data.error;
            this.loader = false;
            return;
          }else{
            this.$router.push({name: "authenticate",});
            this.error = "";
            this.loader = false;
          }
                  
        } else {
          this.error = response.data.msg;
          this.loader = false;
        }
      });
    },
  },
  mounted() {
    document.body.classList.add("auth-body-bg");
  },
};
</script>

<template>
  <div>
    <div class="container-fluid p-0">
      <div class="row g-0">
        <div
          class="col-md-8 d-none d-md-block"
          :style="{
            backgroundImage: `url(${require('@/assets/images/president1.jpg')})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }"
        >
        </div>
        <div class="col-xl-4">
          <div class="auth-full-page-content p-md-5 p-4">
            <div class="w-100">
              <div class="d-flex flex-column h-100">
                <div class="my-auto">
                  <div class="d-flex flex-row">
                    <span class="mt-3"
                      ><br /><img height="60px" src="@/assets/images/logo.jpeg"
                    /></span>
                    <span class="mt-5 ms-3"
                      ><h5 class="text-primary">Welcome Back !</h5>
                      <p class="text-muted">
                        Please authenticate to continue
                      </p></span
                    >
                  </div>
                  <div
                    v-if="error"
                    class="bg-danger text-white p-2 mt-3"
                    style="font-size:12px"
                  >
                    {{ error }}
                  </div>
                  <div class="mt-2">
                    <b-form class="p-2" @submit.prevent="login">
                      
                      <div class="form-group mb-2">
                      <label>Phonenumber</label> <small class="text-danger">*</small>
                      <b-input-group prepend="+256"><input v-model="phone" required placeholder="Enter Phone Number" v-mask="'#########'" type="text" class="form-control"/></b-input-group>
                    </div>
                      <div class="mt-3 d-grid">
                        <b-button type="submit" variant="primary"
                          >Procced
                            <b-spinner
                            v-if="loader"
                            small
                            class="mr-1"
                            label="Small Spinner"
                        /></b-button>
                      </div>
                    </b-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container-fluid -->
  </div>
</template>